import React, { useState } from "react";
import {
    Box,
    Typography,
    Container,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    IconButton,
    Dialog,
    DialogContent,
    Chip,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LaunchIcon from "@mui/icons-material/Launch";
import DownloadIcon from "@mui/icons-material/Download";
import Link from '@mui/material/Link';
import data from "../resources/conference.json"
import publications from "../resources/publications.json"

//import Dheader from "../components/departments/Dheader";

// const publications = [
//     {
//         id: 1,
//         teacherName: "Dr.Suparna Bhattacharya",
//         designation: "Associate Professor, English",
//         publications: [
//             {
//                 title: "AI-driven Predictive Models for Education Analytics",
//                 link: "https://static.muoninfotech.com/./assets/POCO/Bengali Pos & COs.pdf",
//                  tags: ["State Funded", "Research"],
//             },
//             {
//                 title: "Integrating Neural Networks for Smart Learning Systems",
//                 link: "https://example.com/paper2.pdf",
//                 tags: ["State Funded", "Research"],
//             },
//         ],
//         link: '/department/Bengali',

//     },
//     {
//         id: 2,
//         teacherName: "Dr.Nayeem Ahmed",
//         designation: "Associate Professor, Urdu",
//         publications: [
//             {
//                 title: "Quantum Entanglement and Modern Computing",
//                 link: "https://example.com/paper3.pdf",
//                 tags: ["State Funded", "Research"],
                
//             },
//             {
//                 title: "Nano-scale Experiments in Quantum Realms",
//                 link: "https://example.com/paper4.pdf",
//                tags: ["State Funded", "Publication"],
//             },
//         ],
//         link: '/department/Urdu',

//     },
//     {
//         id: 3,
//         teacherName: "Dr.Arkajyoti Jana",
//         designation: "Assistant Professor,Economics",
//         publications: [
//             {
//                 title: "Sustainable Energy Solutions through Chemical Innovation",
//                 link: "https://example.com/paper5.pdf",
//                 tags: ["Chemistry", "Sustainability"],
//                 fund: "state funded",
//                 type: "Research"
//             },
//         ],
//         link: '/department/Bengali',

//     },
//     // Add more teacher entries as needed...
// ];

const bgColors = ["#B5E5DC", "#D6B68A", "#FDEAEB"];

const quickLinks = [
    { name: "Department Overview", link: "/department-overview" },
    { name: "Faculty Directory", link: "/faculty-directory" },
    { name: "Research Areas", link: "/research-areas" },
    { name: "Ongoing Projects", link: "/ongoing-projects" },
    { name: "Student Achievements", link: "/student-achievements" },
    { name: "Contact Department", link: "/contact" },
];

const ResearchPublications = () => {
    const [open, setOpen] = useState(false);
    const [pdfLink, setPdfLink] = useState("");

    const handleOpen = (link) => {
        setPdfLink(link);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    return (
        <>
            <Box sx={{ backgroundColor: "#F6BA6F", py: 3, textAlign: "center" }}>
                <Typography
                    variant="h4"
                    fontWeight={700}
                    color="#fff"
                    sx={{ letterSpacing: 1 }}
                >
                    RESEARCH AND PUBLICATIONS
                </Typography>
            </Box>

            <Container maxWidth="xl" sx={{ py: 6 }}>
                {/* <Typography
        variant="h4"
        fontWeight={700}
        gutterBottom
        textAlign="center"
        mb={5}
      >
        Faculty Research Publications
      </Typography> */}


                <Grid container spacing={3}>
                    {/* Left Sidebar - Quick Links */}
                    <Grid
                        item
                        xs={12}
                        md={3}
                        sx={{
                            position: { md: "sticky" },
                            top: 100,
                            alignSelf: "flex-start",
                            backgroundColor: "#fff",
                            borderRight: "2px solid #f2f2f2",
                            px: { xs: 2, md: 4 },
                            py: 3,
                        }}
                    >
                        <Box>
                            <Typography variant="h6" fontWeight={600} mb={2}>
                                Quick Links
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <List>
                                {quickLinks.map((item, index) => (
                                    <ListItem key={index} disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href={item.link}
                                            sx={{
                                                borderRadius: 2,
                                                "&:hover": {
                                                    backgroundColor: "rgba(0,0,0,0.04)",
                                                },
                                            }}
                                        >
                                            <ListItemText primary={item.name} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>

                    {/* Center + Right Section */}
                    <Grid item xs={12} md={9}>
                        <Grid container spacing={3}>
                            {/* Center - Accordions */}
                            <Grid
                                item
                                xs={12}
                                md={8}
                                sx={{
                                    backgroundColor: "#fff",
                                    px: { xs: 2, md: 4 },
                                    py: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        maxHeight: "80vh",
                                        overflowY: "auto",
                                        "&::-webkit-scrollbar": { width: "8px" },
                                        "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "rgba(0,0,0,0.2)",
                                            borderRadius: "4px",
                                        },
                                    }}
                                >
                                    {publications.map((teacher, index) => (
                                        <Accordion
                                            key={teacher.id}
                                            sx={{
                                                mb: 3,
                                                borderRadius: 2,
                                                width: "100%",
                                                backgroundColor: bgColors[index % bgColors.length],
                                                boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                                                "&:before": { display: "none" },
                                            }}
                                        >
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Box>
                                                    <Typography variant="h6" fontWeight={600}>
                                                        {teacher.teacherName}


                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {teacher.designation}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        <Link href={teacher.link}>Click to visit Department</Link>
                                                    </Typography>
                                                </Box>
                                            </AccordionSummary>

                                            <AccordionDetails>
                                                {teacher.publications.map((pub, i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            mb: 2,
                                                            px: 2,
                                                            py: 2,
                                                            borderRadius: 2,
                                                            backgroundColor: "rgba(255,255,255,0.7)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            flexWrap: "wrap",
                                                        }}
                                                    >
                                                        <Box>
                                                            <Typography variant="subtitle1" fontWeight={600}>
                                                                {pub.title}
                                                            </Typography>
                                                            <Box mt={1}>
                                                                {pub.tags.map((tag, idx) => (
                                                                    <Chip
                                                                        key={idx}
                                                                        label={tag}
                                                                        color="primary"
                                                                        size="small"
                                                                        sx={{ mr: 1 }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        </Box>

                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            gap={1}
                                                            mt={{ xs: 2, md: 0 }}
                                                        >
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<LaunchIcon />}
                                                                onClick={() => handleOpen(pub.link)}
                                                            >
                                                                View
                                                            </Button>
                                                            <IconButton
                                                                color="primary"
                                                                onClick={() => window.open(pub.link, "_blank")}
                                                            >
                                                                <DownloadIcon />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Box>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={4}
                                sx={{
                                    p: 3,
                                    backgroundColor: "#6EA9E4",
                                    borderRadius: 3,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    height: "fit-content",
                                    alignSelf: "flex-start",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight={700}
                                    mb={2}
                                    sx={{ fontFamily: "DM Sans", color: "whitesmoke" }}
                                >
                                    Upcoming Conferences
                                </Typography>

                                <List>
                                    {data.map((conference, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? "#FFF" : "#FFF3E0",
                                                mb: 1,
                                                borderRadius: 2,
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                            }}
                                            secondaryAction={
                                                <IconButton
                                                    edge="end"
                                                    aria-label="download"
                                                    href={conference.pdf}
                                                    target="_blank"
                                                    rel="noopener"
                                                >
                                                    <DownloadIcon sx={{ color: "#6EA9E4" }} />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemText
                                                primary={conference.title}
                                                secondary={conference.details}
                                                primaryTypographyProps={{
                                                    fontWeight: 600,
                                                    color: "#3E2723",
                                                    fontFamily: "DM Sans",
                                                }}
                                                secondaryTypographyProps={{
                                                    fontSize: "0.9rem",
                                                    color: "#5D4037",
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>



                {/* PDF Overlay Dialog */}
                <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                    <DialogContent sx={{ p: 0, height: "80vh" }}>
                        <iframe
                            src={pdfLink}
                            title="Research Paper"
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                        />
                    </DialogContent>
                </Dialog>
            </Container>
        </>
    );
};

export default ResearchPublications;
